import React from "react";

const Error = () => {
  return <h1 style={{ textAlign: "center" }}>OOps! Page Not Found! </h1>;
};

export default Error;
